<div mat-dialog-actions class="d-flex flex-column-reverse flex-sm-row justify-content-between">
  <button mat-button [mat-dialog-close]="false">{{'COMMON.cancel' | translate }}</button>
  <button class="profile-delete-warning-dialog__delete-btn" mat-button [mat-dialog-close]="true">
    {{'PROFILE.yes_delete' | translate }}
  </button>
</div>